import { cx } from '@linaria/core';
import { useMediaQuery } from '@react-hookz/web';

import { routes } from '~constants/routes';
import { useDialogs } from '~entities/dialogs';
import { useNavigationLinks } from '~hooks/useNavigationLinks';
import { UnreadMessagesBadge } from '~shared/ui/atoms';

import {
	HeaderLink,
	HeaderLinksWrapper,
	unreadMessagesClass,
} from './HeaderLinks.styles';

export const HeaderLinks = () => {
	const isSmallDesktop = useMediaQuery('screen and (max-width: 1200px)');

	const links = useNavigationLinks();
	const { unreadMessagesCount } = useDialogs();

	return (
		<HeaderLinksWrapper>
			{links.map(({ path, text, shortText, active, handle }) => (
				<HeaderLink
					key={path}
					className={cx(active && 'active')}
					href={path}
					prefetch={false}
					onClick={handle}
				>
					<span>{isSmallDesktop ? shortText : text}</span>
					{path === routes.chats.home && unreadMessagesCount > 0 && (
						<UnreadMessagesBadge
							className={unreadMessagesClass}
							count={unreadMessagesCount}
						/>
					)}
				</HeaderLink>
			))}
		</HeaderLinksWrapper>
	);
};
